module.exports = __webpack_public_path__ + "static/media/15.924e2203.png";